import { useNavigate } from "react-router-dom";

// Mui
import { Stack } from "@mui/material";
import "./Signin.css";

// Local
import AuthCard from "../../components/UI/Cards/AuthCard";
import FormFieldsContainer from "../../components/Layout/FormFieldsContainer";
import PrimaryTextField from "../../components/UI/Form/PrimaryTextField";
import PrimaryButton from "../../components/UI/Buttons/PrimaryButton";
import {
  Button,
  Container,
  Icon,
  InputField,
  InputPhoneDropdown,
  Notifications,
  Spinner,
} from "@jds/core";
import useInput from "../../hooks/use-input";
import { validatePhoneNumber, validateTextInput } from "../../util/validation";
import useApiHttp from "../../hooks/use-http";
import { useState } from "react";
import { countryPhoneCodes } from "../../util/helper";

export default function Signin(props) {
  const navigate = useNavigate();
  const getOtpClickHandler = () => {
    navigate("/auth/otp");
  };
  const [selectedCountry, setSelectedCountry] = useState(0);

  const countryCodeItems = countryPhoneCodes.map((obj) => ({
    label: obj?.dial_code,
    value: obj?.dial_code,
  }));

  const {
    value: value,
    isValid: isValidvalue,
    hasError: valueError,
    valueChangeHandler: valueChangeHandler,
    inputBlurHandler: valueBlurHandler,
    reset: resetValue,
  } = useInput(validatePhoneNumber);

  const { sendRequest: signInUser, isLoading } = useApiHttp();
  const isValidForm = !isValidvalue;

  const handleSubmit = (e) => {
    e.preventDefault();
    const countryCode = countryCodeItems.filter((items, index) => {
      if (index == selectedCountry) {
        return items;
      }
    })[0]?.value;

    signInUser(
      {
        base: "AUTH",
        isBearer: false,
        url: `user/web-login`,
        method: "POST",
        // body: {
        //   phone_number: `+91${value}`,
        // },
        body: {
          countryCode: countryCode,
          phoneNumber: value,
        },
      },
      null,
      (data) => {
        navigate("/auth/otp", {
          // state: {
          //   phone_number: `+91${value}`,
          // },
          state: {
            phoneNumber: value,
            countryCode: countryCode,
            identifier: data?.data?.identifier,
          },
        });
        Notifications.toast.success({ id: "sign-in", title: data.message });
      },
      (err, data) => {
        Notifications.toast.success({ id: "sign-in", title: data.message });
      }
    );
  };
  return (
    <>
      <AuthCard title="in">
        <form onSubmit={handleSubmit}>
          <Container
            direction="column"
            style={{ marginTop: "48px" }}
            gap={68}
            fullWidth
          >
            <InputField
              type="number"
              value={value}
              stateText="Invalid phone number"
              onChange={valueChangeHandler}
              onBlur={valueBlurHandler}
              state={valueError ? "error" : ""}
              label="Phone number"
              name="value"
              prefix={
                <InputPhoneDropdown
                  selectedIndex={selectedCountry}
                  items={countryCodeItems}
                  onSelect={(idx) => {
                    setSelectedCountry(idx);
                  }}
                />
              }
            />
            <Button
              type="submit"
              fullWidth
              disabled={isValidForm}
              kind={isLoading ? "secondary" : "primary"}
              size="large"
              label="Button"
            >
              {isLoading ? (
                <Spinner kind="vibrant" label="Loading..." size="small" />
              ) : (
                "Get OTP"
              )}
            </Button>
          </Container>
        </form>
      </AuthCard>
    </>
  );
}
